export default __webpack_public_path__ + "static/icecream-health-1-desktop-9760d38bc6328df3df8d8d409357e882.png";